import {
  BadgeCheckIcon,
  BrainCircuitIcon,
  GraduationCapIcon,
  HandCoinsIcon,
  LeafIcon,
  MegaphoneIcon,
  NetworkIcon,
  PiggyBankIcon,
  ShieldCheckIcon,
  TrendingUpIcon,
} from 'lucide-react'
import type { Proposal } from '../types/landing'

export const proposals: Proposal[] = [
  { number: '01', title: 'IA y datos para MiPymes', description: 'Herramientas para optimizar procesos y explorar nuevos mercados.', icon: BrainCircuitIcon },
  { number: '02', title: 'Red de consultores', description: 'Conectar expertos con las necesidades reales de las empresas.', icon: NetworkIcon },
  { number: '03', title: 'Proyectos y cofinanciación', description: 'Acercar programas y fuentes de apoyo a las empresas de la región.', icon: HandCoinsIcon },
  { number: '04', title: 'Transformación digital segura', description: 'Servicios ágiles, accesibles y buenas prácticas de ciberseguridad.', icon: ShieldCheckIcon },
  { number: '05', title: 'Austeridad con impacto', description: 'Uso eficiente de recursos e inversión en desarrollo empresarial.', icon: PiggyBankIcon },
  { number: '06', title: 'Afiliación y beneficios', description: 'Una ruta clara de vinculación y valor para los afiliados.', icon: BadgeCheckIcon },
  { number: '07', title: 'Habilidades del futuro', description: 'Formación en productividad, tecnología y gestión.', icon: GraduationCapIcon },
  { number: '08', title: 'Visibilidad empresarial', description: 'Compartir casos de éxito y aprendizajes regionales.', icon: MegaphoneIcon },
  { number: '09', title: 'Formalización y crecimiento', description: 'Acompañar a las empresas en cada etapa de su consolidación.', icon: TrendingUpIcon },
  { number: '10', title: 'Región sostenible', description: 'Prácticas que fortalecen una competitividad responsable y sostenible.', icon: LeafIcon },
]
